<p>dialog-sign-in works!</p>
